import { render, staticRenderFns } from "./AgmPrivacy.vue?vue&type=template&id=f980c99c&scoped=true&"
var script = {}
import style0 from "./AgmPrivacy.vue?vue&type=style&index=0&id=f980c99c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f980c99c",
  null
  
)

export default component.exports